module.exports = __webpack_public_path__ + "media/images/ebs-bg-blue-pattern-16388e8d.jpg";